var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-05
 * @brief EHP 메시지 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
/**
 * @brief EHP 메시지 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function HttpMsgList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //
    const [messageList, setMessageList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [codeParam, setCodeParam] = useState("");
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (codeParam.length > 0) {
        appPath = appPath + "&menuCode=" + codeParam;
    }
    const [listReload, setListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    //{menuCode, menuName, errList : {}}
    //[{"field":"menuName","msg":"필수 항목입니다."}]
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/message/httpmessages?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + listReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN CHECK MESSAGE LIST : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setListReload(false); // list reload
                setMessageList(retData.body);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
            }
        }
    }, [selTree, retData]);
    //////////////////
    function handleListReload(val, page) {
        if (page > -1)
            handleCurPage([page]);
        setListReload(val);
    }
    useEffect(() => {
        setParentPopWin("pop-message-add", React.createElement(PopupHttpMessageInsert, { htmlHeader: React.createElement("h1", null, "HTTP \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
    }, [listReload]);
    function onClickInsertErrorMessage(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-add");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "796");
        setParentPopWin("pop-message-add", React.createElement(PopupHttpMessageInsert, { htmlHeader: React.createElement("h1", null, "HTTP \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickViewHttpMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        setParentPopWin("pop-message", React.createElement(PopupHttpMessageView, { htmlHeader: React.createElement("h1", null, "HTTP \uBA54\uC138\uC9C0"), httpMessage: message, listReload: listReload, setListReload: handleListReload, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickDeleteHttpMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-delete");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "200");
        setParentPopWin("pop-delete", React.createElement(PopupHttpMessageDelete, { htmlHeader: React.createElement("h1", null, "\uC0AD\uC81C"), httpMessage: message, listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "HTTP \uBA54\uC138\uC9C0")),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-message-add", 
                        /* onClick={(e) => onClickInsertErrorMessage(e)} */
                        disabled // 사용 시 제거 및 onClick 주석 해체
                        : true },
                        React.createElement("span", null, "\uCD94\uAC00")))),
            React.createElement("div", { className: "tbl-list message-list" },
                React.createElement("table", { summary: "\uC5D0\uB7EC\uCF54\uB4DC,\uBA54\uC138\uC9C0,\uC194\uB8E8\uC158,HTTP \uCF54\uB4DC,\uC5B8\uC5B4,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C HTTP \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "HTTP \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "12%" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "9%" } }),
                        React.createElement("col", { style: { "width": "190px" } }),
                        React.createElement("col", { style: { "width": "6%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBA54\uC138\uC9C0"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC194\uB8E8\uC158"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "HTTP \uCF54\uB4DC"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5B8\uC5B4"),
                            React.createElement("th", { scope: "col" }, "\uC0AD\uC81C"))),
                    React.createElement("tbody", null, messageList.map((msg, idx) => (React.createElement("tr", { key: `http_tr_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewHttpMessage(e, msg) }, msg.errorCode),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewHttpMessage(e, msg) }, msg.messageKorean),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewHttpMessage(e, msg) }, msg.solutionKorean),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewHttpMessage(e, msg) }, msg.httpCode),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewHttpMessage(e, msg) },
                            React.createElement("ul", { className: "messagelang" },
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageKorean) && msg.messageKorean.length > 0) ? "on" : "" }, "\uD55C\uAD6D\uC5B4"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageEnglish) && msg.messageEnglish.length > 0) ? "on" : "" }, "English"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.messageChinese) && msg.messageChinese.length > 0) ? "on" : "" }, "\u4E2D\u6587"))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", 
                                /* onClick={(e) => onClickDeleteHttpMessage(e, msg)} */
                                disabled // 사용 시 제거 및 onClick 주석 해체
                                : true },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))))))))),
            React.createElement(EhpPagination, { componentName: "HTTPMESSAGELIST", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default HttpMsgList;
function PopupHttpMessageInsert(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    const defaultVal = {
        "errorCode": "",
        "httpCode": "",
        "messageKorean": "",
        "messageEnglish": "",
        "messageChinese": "",
        "solutionKorean": "",
        "solutionEnglish": "",
        "solutionChinese": "",
    };
    const [httpMessage, setHttpMessage] = useState(defaultVal);
    clog("IN POP INSERT : " + listReload);
    useEffect(() => {
        setHttpMessage(defaultVal);
    }, [listReload]);
    function callbackSetHttpMessageKor(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageKorean: val }));
    }
    function callbackSetHttpSolutionKor(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionKorean: val }));
    }
    function callbackSetHttpMessageEng(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageEnglish: val }));
    }
    function callbackSetHttpSolutionEng(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionEnglish: val }));
    }
    function callbackSetHttpMessageCha(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageChinese: val }));
    }
    function callbackSetHttpSolutionCha(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionChinese: val }));
    }
    const [errorList, setErrorList] = useState([]);
    function onClickDoSaveHttpMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doSaveHttpMessage({
                "errorCode": httpMessage.errorCode,
                "httpCode": httpMessage.httpCode,
                "message": httpMessage.messageKorean,
                "solution": httpMessage.solutionKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN HTTP MSG : KOR INSERT : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doSaveHttpMessage({
                    "errorCode": httpMessage.errorCode,
                    "httpCode": httpMessage.httpCode,
                    "message": httpMessage.messageEnglish,
                    "solution": httpMessage.solutionEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN HTTP MSG : ENG INSERT : " + JSON.stringify(data.body));
                    }
                    else { //english
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doSaveHttpMessage({
                        "errorCode": httpMessage.errorCode,
                        "httpCode": httpMessage.httpCode,
                        "message": httpMessage.messageChinese,
                        "solution": httpMessage.solutionChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN HTTP MSG : CHA INSERT : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            //errList.push({"field":});
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        if (doCnt === succCnt) {
                            setParentListReload(true, 0);
                            CUTIL.jsclose_Popup("pop-message-add");
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doSaveHttpMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/message/httpmessage`,
                appQuery: {
                    "errorCode": cmsg.errorCode,
                    "httpCode": cmsg.httpCode,
                    "message": cmsg.message,
                    "solution": cmsg.solution,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-message-add");
        setParentListReload(true, 0);
    }
    clog("IN HTTP INSER ERR : " + JSON.stringify(errorList));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("errorCode")).length > 0) ? "input-error" : "", value: httpMessage.errorCode, onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { errorCode: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("errorCode") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageKorean")).length > 0) ? "input-error" : "", value: httpMessage.messageKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageKor), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageEnglish")).length > 0) ? "input-error" : "", value: httpMessage.messageEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageEng), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageChinese")).length > 0) ? "input-error" : "", value: httpMessage.messageChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageCha), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC194\uB8E8\uC158")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionKorean")).length > 0) ? "input-error" : "", value: httpMessage.solutionKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionKor), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionEnglish")).length > 0) ? "input-error" : "", value: httpMessage.solutionEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionEng), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionChinese")).length > 0) ? "input-error" : "", value: httpMessage.solutionChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionCha), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "HTTP\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("httpCode")).length > 0) ? "input-error" : "", value: httpMessage.httpCode, onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { httpCode: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("httpCode") && (idx === 0)).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoSaveHttpMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupHttpMessageView(props) {
    //props
    const setParentPopWin = props.setPopWin;
    //
    const [httpMessage, setHttpMessage] = useState(null);
    //const onClickUpdateCheckMessage = props.onClickUpdateCheckMessage;
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const [updateCount, setUpdateCount] = useState(0);
    useEffect(() => {
        setHttpMessage(props.httpMessage);
        setUpdateCount(0);
    }, [props.httpMessage]);
    function onClickUpdateHttpMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-edit");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message-edit", React.createElement(PopupHttpMessageUpdate, { htmlHeader: React.createElement("h1", null, "HTTP \uBA54\uC138\uC9C0"), httpMessage: message, listReload: listReload, setListReload: props.setListReload, updateCount: updateCount, setUpdateCount: setUpdateCount, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickCancel(e) {
        //setParentListReload(true);
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message", null);
    }
    //clog("IN VIEW : INIT : " + JSON.stringify(httpMessage));
    return (React.createElement(React.Fragment, null,
        (httpMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: httpMessage.errorCode, disabled: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.messageKorean) ? "" : httpMessage.messageKorean, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.messageEnglish) ? "" : httpMessage.messageEnglish, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.messageChinese) ? "" : httpMessage.messageChinese, readOnly: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC194\uB8E8\uC158")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.solutionKorean) ? "" : httpMessage.solutionKorean, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.solutionEnglish) ? "" : httpMessage.solutionEnglish, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(httpMessage.solutionChinese) ? "" : httpMessage.solutionChinese, readOnly: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "HTTP\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: httpMessage.httpCode, disabled: true }))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-open btn-close", "data-pop": "pop-message-edit", onClick: (e) => onClickUpdateHttpMessage(e, httpMessage) },
                React.createElement("span", null, "\uC218\uC815")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function PopupHttpMessageUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const setParentPopWin = props.setPopWin;
    //
    const [httpMessage, setHttpMessage] = useState(null);
    const [errorList, setErrorList] = useState([]);
    //
    useEffect(() => {
        setHttpMessage(props.httpMessage);
    }, [updateCount, props.httpMessage]);
    function callbackSetHttpMessageKor(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageKorean: val }));
    }
    function callbackSetHttpMessageEng(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageEnglish: val }));
    }
    function callbackSetHttpMessageCha(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageChinese: val }));
    }
    function callbackSetHttpSolutionKor(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionKorean: val }));
    }
    function callbackSetHttpSolutionEng(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionEnglish: val }));
    }
    function callbackSetHttpSolutionCha(val) {
        setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionChinese: val }));
    }
    function onClickDoUpdateHttpMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doUpdateHttpMessage({
                "errorCode": httpMessage.errorCode,
                "httpCode": httpMessage.httpCode,
                "message": httpMessage.messageKorean,
                "solution": httpMessage.solutionKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN HTTP MSG : KOR UPDATE : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    //errList.push({ "err-field": CONST.STR_APILANG_KOR, "msg": data.body.errorList });
                    clog("IN HTTP ERROR : KOR : " + JSON.stringify(data));
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doUpdateHttpMessage({
                    "errorCode": httpMessage.errorCode,
                    "httpCode": httpMessage.httpCode,
                    "message": httpMessage.messageEnglish,
                    "solution": httpMessage.solutionEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN HTTP MSG : ENG UPDATE : " + JSON.stringify(data.body));
                        //setParentHttpMessage()
                    }
                    else { //english
                        //errList.push({ "err-field": CONST.STR_APILANG_ENG, "msg": data.body.errorList });
                        clog("IN HTTP ERROR : ENG : " + JSON.stringify(edata));
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doUpdateHttpMessage({
                        "errorCode": httpMessage.errorCode,
                        "httpCode": httpMessage.httpCode,
                        "message": httpMessage.messageChinese,
                        "solution": httpMessage.solutionChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN HTTP MSG : CHA UPDATE : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        setParentListReload(true, -1); // only list reload & page reset done
                        ////
                        setParentPopWin("pop-message", React.createElement(PopupHttpMessageView, { htmlHeader: React.createElement("h1", null, "HTTP \uBA54\uC138\uC9C0"), httpMessage: httpMessage, listReload: listReload, setListReload: props.setListReload, setPopWin: props.setPopWin }));
                        if (doCnt === succCnt) {
                            CUTIL.jsclose_Popup("pop-message-edit");
                            var popupVal = e.target.getAttribute("data-pop");
                            if (CUTIL.isnull(popupVal))
                                e.target.setAttribute("data-pop", "pop-message");
                            CUTIL.jsopen_Popup(e);
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doUpdateHttpMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("doUpdateHttpMessage : " + JSON.stringify(cmsg));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/message/httpmessage`,
                appQuery: {
                    "errorCode": cmsg.errorCode,
                    "httpCode": cmsg.httpCode,
                    "message": cmsg.message,
                    "solution": cmsg.solution,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        CUTIL.jsclose_Popup("pop-message-edit");
        setParentPopWin("pop-message-edit", null);
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
        setParentUpdateCount(updateCount + 1);
    }
    clog("IN HTTPMSG : INIT : " + JSON.stringify(errorList));
    return (React.createElement(React.Fragment, null,
        (httpMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC5D0\uB7EC\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("errorCode")).length > 0) ? "input-error" : "", value: httpMessage.errorCode, onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { errorCode: e.target.value })), disabled: true }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("errorCode") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageKorean")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.messageKorean) ? "" : httpMessage.messageKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageKor), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageEnglish")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.messageEnglish) ? "" : httpMessage.messageEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageEng), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "messageChinese")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.messageChinese) ? "" : httpMessage.messageChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpMessageCha), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { messageChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "messageChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC194\uB8E8\uC158")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionKorean")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.solutionKorean) ? "" : httpMessage.solutionKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionKor), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionEnglish")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.solutionEnglish) ? "" : httpMessage.solutionEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionEng), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "solutionChinese")).length > 0) ? "input-error" : "", value: CUTIL.isnull(httpMessage.solutionChinese) ? "" : httpMessage.solutionChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetHttpSolutionCha), onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { solutionChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "solutionChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "HTTP\uCF54\uB4DC"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("httpCode")).length > 0) ? "input-error" : "", value: httpMessage.httpCode, onChange: (e) => setHttpMessage(Object.assign(Object.assign({}, httpMessage), { httpCode: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("httpCode") && (idx === 0)).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateHttpMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupHttpMessageDelete(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const setParentListReload = props.setListReload;
    const [httpMessage, setHttpMessage] = useState(null);
    useEffect(() => {
        setHttpMessage(props.httpMessage);
    }, [props.httpMessage]);
    function onClickDoDeleteHttpMessage(e, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/message/httpmessage`,
                appQuery: {
                    "errorCode": message.errorCode,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    clog("IN COMPANY : onClickDoSaveCompany : " + JSON.stringify(data.body));
                    CUTIL.jsclose_Popup("pop-delete");
                    setParentListReload(true, 0);
                }
                else { // api if
                    // need error handle
                    alert("ERROR : " + JSON.stringify(data.body.errorList));
                }
            }
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-delete");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uD574\uB2F9 \uC5D0\uB7EC\uBA54\uC138\uC9C0\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickDoDeleteHttpMessage(e, httpMessage) },
                React.createElement("span", null, "\uD655\uC778")))));
}
